module.exports = __webpack_public_path__ + "img/dosificacion_4.cc955055.png";